angular.module 'zc.master'

.directive 'zcLabelUserRole', ($state, Devise) ->
  directive =
    restrict: "EA"
    scope: {
      user: '='
    }
    template: '''
    <span
      class="label label-danger"
      ng-if="user.role === 'master'">
      {{user.role}}
    </span>
    <span
      class="label label-success"
      ng-if="user.role === 'common'">
      {{user.role}}
    </span>
    <span
      class="label label-info"
      ng-if="user.role === 'internal'">
      {{user.role}}
    </span>
    '''

  directive




// WEBPACK FOOTER //
// ./src/master_admin_modules/master/directives/label_user_role.directive.coffee